// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Deliveries_page__-JiB7 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Deliveries_header__Hgd47 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.Deliveries_title__G8ecD {
  font-size: 26px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.Deliveries_headerActions__LqpLK {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.Deliveries_newBtn__vCN6E {
  white-space: nowrap;
  background: var(--dylo-orange) !important;
  border: none !important;
}
.Deliveries_newBtn__vCN6E:hover {
  background: var(--dylo-orange-hover) !important;
}
.Deliveries_search__aITS7 {
  width: 300px;
  max-width: 100%;
}

/* ===== Tabla ===== */
.Deliveries_tableWrap__hs1Vr {
  width: 100%;
  overflow-x: auto;
}
.Deliveries_tableHead__RXNps,
.Deliveries_row__sQYqn {
  display: grid;
  /* Name, SCAC, Mail, Phone, Client, Actions. Sin "User" desde el 13-oct-2026 (rol Delivery quitado). */
  grid-template-columns: 1.6fr 0.7fr 1.5fr 1fr 1.6fr 0.9fr;
  align-items: center;
  gap: 12px;
  min-width: 800px;
}
.Deliveries_tableHead__RXNps {
  padding: 12px 18px;
  background: var(--dylo-field-bg);
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.Deliveries_tableBody__8bDRV {
  display: flex;
  flex-direction: column;
}
.Deliveries_row__sQYqn {
  padding: 15px 18px;
  border-bottom: 1px solid var(--dylo-line);
  font-size: 13px;
  color: var(--dylo-ink);
  animation: Deliveries_dylo-fade-in__QDGk1 0.28s ease both;
}
.Deliveries_row__sQYqn:last-child {
  border-bottom: none;
}
.Deliveries_center__69o58 {
  text-align: center;
  justify-self: center;
}
.Deliveries_name__fNYwY {
  font-weight: 600;
  color: var(--dylo-ink);
}
.Deliveries_muted__MYP2C {
  color: var(--dylo-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Deliveries_detailBtn__OAZs2 {
  padding: 6px 18px !important;
  border: 1px solid var(--dylo-surface-border) !important;
  background: transparent !important;
  color: var(--dylo-ink) !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}
.Deliveries_detailBtn__OAZs2:hover {
  border-color: var(--dylo-teal-500) !important;
  color: var(--dylo-teal-700) !important;
}

.Deliveries_empty__1sy4U {
  padding: 40px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 14px;
}

.Deliveries_skRounded__IJu27 {
  border-radius: 999px !important;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Deliveries/Deliveries.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sGAAsG;EACtG,wDAAwD;EACxD,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,sBAAsB;EACtB,yDAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,uDAAuD;EACvD,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n.title {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.newBtn {\n  white-space: nowrap;\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.newBtn:hover {\n  background: var(--dylo-orange-hover) !important;\n}\n.search {\n  width: 300px;\n  max-width: 100%;\n}\n\n/* ===== Tabla ===== */\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n}\n.tableHead,\n.row {\n  display: grid;\n  /* Name, SCAC, Mail, Phone, Client, Actions. Sin \"User\" desde el 13-oct-2026 (rol Delivery quitado). */\n  grid-template-columns: 1.6fr 0.7fr 1.5fr 1fr 1.6fr 0.9fr;\n  align-items: center;\n  gap: 12px;\n  min-width: 800px;\n}\n.tableHead {\n  padding: 12px 18px;\n  background: var(--dylo-field-bg);\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.tableBody {\n  display: flex;\n  flex-direction: column;\n}\n.row {\n  padding: 15px 18px;\n  border-bottom: 1px solid var(--dylo-line);\n  font-size: 13px;\n  color: var(--dylo-ink);\n  animation: dylo-fade-in 0.28s ease both;\n}\n.row:last-child {\n  border-bottom: none;\n}\n.center {\n  text-align: center;\n  justify-self: center;\n}\n.name {\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.muted {\n  color: var(--dylo-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.detailBtn {\n  padding: 6px 18px !important;\n  border: 1px solid var(--dylo-surface-border) !important;\n  background: transparent !important;\n  color: var(--dylo-ink) !important;\n  font-size: 12.5px !important;\n  border-radius: 8px !important;\n}\n.detailBtn:hover {\n  border-color: var(--dylo-teal-500) !important;\n  color: var(--dylo-teal-700) !important;\n}\n\n.empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 14px;\n}\n\n.skRounded {\n  border-radius: 999px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Deliveries_page__-JiB7`,
	"header": `Deliveries_header__Hgd47`,
	"title": `Deliveries_title__G8ecD`,
	"headerActions": `Deliveries_headerActions__LqpLK`,
	"newBtn": `Deliveries_newBtn__vCN6E`,
	"search": `Deliveries_search__aITS7`,
	"tableWrap": `Deliveries_tableWrap__hs1Vr`,
	"tableHead": `Deliveries_tableHead__RXNps`,
	"row": `Deliveries_row__sQYqn`,
	"tableBody": `Deliveries_tableBody__8bDRV`,
	"dylo-fade-in": `Deliveries_dylo-fade-in__QDGk1`,
	"center": `Deliveries_center__69o58`,
	"name": `Deliveries_name__fNYwY`,
	"muted": `Deliveries_muted__MYP2C`,
	"detailBtn": `Deliveries_detailBtn__OAZs2`,
	"empty": `Deliveries_empty__1sy4U`,
	"skRounded": `Deliveries_skRounded__IJu27`
};
export default ___CSS_LOADER_EXPORT___;
